import { PayloadAction } from '@reduxjs/toolkit';
import { IState } from '../types/state';

const setSpecialEventForAuthorizedUsers = (
  state: IState,
  action: PayloadAction<{ value: boolean }>,
) => {
  state.activeSpecialEvent.onlyForAuthorizedUsers = action.payload.value;
};

export default setSpecialEventForAuthorizedUsers;
